import React from 'react'
import { util } from 'meinian-package/src/utils'
import Button from 'meinian-package/src/baseComponent/button'
import SampleCardExamine from 'component/waterfall.card/sampleCardExamine'
import MoreOperation from '../moreOperation'
import styles from './index.module.less'

export default ({
  stepId,
  stepStatus,
  setVisible,
  id,
  process,
  setIsAnnotate,
  onUpdateSampleStatus
}) => {
  const isComputeAll = () => {
    return process.steps.length === process.steps.findIndex(item => item.id === stepId) + 1 && stepStatus === 3
  }
  const isState = () => {
    return stepStatus === 0 || stepStatus === 2
  }
  return <div className={styles['sample-detail-options']} onClick={() => setIsAnnotate?.(false)}>
    {
      (stepStatus === -1 || isComputeAll()) ? <div className="options-btn-wrap">
        <Button
          type="primary"
          className="sample-edit-btn"
          style={{ flex: '1' }}
          onClick={() => {
            util.track('mn_edit_sample', {
              module1: '样衣详情页',
              module2: '基本信息'
            })
            setVisible(true)
          }}
        >编辑样衣</Button>
      </div> : <div className="options-btn-wrap">
        <div className="options-btn-wrap-left">
          {
            !isState() && <SampleCardExamine.Recall
              id={id}
              onClick={onUpdateSampleStatus}
              className="sample-detail-options-recall"
            />
          }
          <SampleCardExamine.Process
            className="sample-detail-options-process"
            process={process}
            stepId={stepId}
            stepStatus={stepStatus}
            id={id}
            onClick={onUpdateSampleStatus}
          />
        </div>
        <div className="df-center">
          <Button
            type="primary"
            className="sample-edit-btn"
            onClick={() => {
              util.track('mn_edit_sample', {
                module1: '样衣详情页',
                module2: '基本信息'
              })
              setVisible(true)
            }}
          >编辑样衣</Button>
          <MoreOperation
            onClick={onUpdateSampleStatus}
            id={id}
          />
        </div>
      </div>
    }
  </div>
}
